import { FC } from 'react';
import styled from 'styled-components';
import Card from './ui/Card';
import { ButtonRow, GoldButton, OutlineButton } from './ui/Buttons';

interface BackgroundConfirmCardProps {
	open: boolean;
	image: string;
	/** 0-100 */
	grayscale: number;
	/** 0-1 */
	opacity: number;
	onProceed: () => void;
	onSkip: () => void;
	step?: number;
	totalSteps?: number;
}

/** "Background image" confirmation, the last import step (style guide R14 step 4). */
const BackgroundConfirmCard: FC<BackgroundConfirmCardProps> = ({ open, image, grayscale, opacity, onProceed, onSkip, step, totalSteps }) => (
	<Card
		open={open}
		title="Background image"
		step={step}
		totalSteps={totalSteps}
		description="If you're happy with the image below, tap Proceed. Tap Skip to draw without it."
		note="Note: The image will be scaled to fit your canvas, which may change its proportions if the canvas is not square. It won't be part of your artwork."
	>
		<Frame>
			<Preview src={image} alt="Background image" style={{ filter: `grayscale(${grayscale}%)`, opacity }} />
		</Frame>
		<ButtonRow>
			<OutlineButton type="button" onClick={onSkip}>
				Skip
			</OutlineButton>
			<GoldButton type="button" onClick={onProceed}>
				Proceed
			</GoldButton>
		</ButtonRow>
	</Card>
);

export default BackgroundConfirmCard;

const Frame = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 20px;
	padding: 12px;
	background-color: #000;
	border-radius: 10px;
`;

const Preview = styled.img`
	width: 100%;
	max-width: 260px;
	aspect-ratio: 1;
	object-fit: contain;
`;
